<template>
  <UICard class="modal-wrapper" elevation="high">
    <slot v-if="$slots.header || $slots.title || title" name="header">
      <UICardHeader underline no-backdrop-blur class="sticky top-0 bg-white">
        <UICardTitle>
          <slot name="title">{{ title }}</slot>
        </UICardTitle>
        <template #actions>
          <UIHelpLink v-if="helpLink" :link="helpLink" />
        </template>
      </UICardHeader>
    </slot>
    <UICardBody data-test-id="card-modal-content">
      <slot />
    </UICardBody>
    <template v-if="$slots.footer" #footer>
      <footer class="modal-body-footer sticky bottom-0 w-full bg-white px-4">
        <div class="border-t border-grey-300 py-3">
          <slot name="footer" />
        </div>
      </footer>
    </template>
  </UICard>
</template>

<script lang="ts" setup>
import UICardBody from 'shared/ui/registry/kinnovis/ui-card-body/UICardBody.vue';
import UICardHeader from 'shared/ui/registry/kinnovis/ui-card-header/UICardHeader.vue';
import UICardTitle from 'shared/ui/registry/kinnovis/ui-card-title/UICardTitle.vue';
import UICard from 'shared/ui/registry/kinnovis/ui-card/UICard.vue';
import type { IHelpLink } from 'shared/ui/registry/kinnovis/ui-help-link/UIHelpLink.vue';
import UIHelpLink from 'shared/ui/registry/kinnovis/ui-help-link/UIHelpLink.vue';

interface Props {
  title?: string;
  helpLink?: IHelpLink;
}

withDefaults(defineProps<Props>(), {
  title: undefined,
  helpLink: undefined,
});
</script>

<style lang="scss" scoped>
.modal-container {
  overflow-y: hidden;
  overflow-x: hidden;
}

:deep(.container--fluid) {
  padding: 0;
  overflow: hidden;
}

.modal-wrapper {
  overflow-y: auto;
  max-height: 90vh;
}
</style>
